import { render, staticRenderFns } from "./GameSurveys.vue?vue&type=template&id=8add3c02"
import script from "./GameSurveys.vue?vue&type=script&lang=js"
export * from "./GameSurveys.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports